/**
 * @flow
 * @author: Pavan
 */

import {
  borderColor,
  errorBorderColor,
  focussedBorderColor
} from './themeConstants'

const styles = {
  errorStyles: {
    border: `1px solid ${errorBorderColor}`
  },
  defaultStyles: {
    border: `1px solid ${borderColor}`
  },
  focusedStyles: {
    border: `1px solid ${focussedBorderColor}`
  }
}

export default styles



// WEBPACK FOOTER //
// ./src/commons/BaseDateField/styles.js